import { defineNuxtPlugin, useState } from '#app'
import { useMainStore } from '../stores/main-store'

export default defineNuxtPlugin(async (nuxtApp) => {
  const { $axios } = nuxtApp
  const mainStore = useMainStore()

  const detectedCountryState = useState('detectedCountry')
  const categories = useState('categories', () => [])
  const countries = useState('countries', () => [])
  const languages = useState('languages', () => [])
  const currencies = useState('currencies', () => [])

  function abortNavigation({ statusCode, message }) {
    throw createError({ statusCode, statusMessage: message })
  }

  async function getCategories() {
    try {
      const response = await $axios.get('category')
      categories.value = response.data.data.map((category) => ({
        ...category,
        label: category.name,
        value: category.id,
      }))
      return response
    } catch (error) {
      abortNavigation({
        statusCode: error.response?.status || 500,
        message: error.message,
      })
    }
  }

  async function getCountries() {
    try {
      const response = await $axios.get('country')
      countries.value = response.data.data.map((country) => ({
        ...country,
        label: country.name,
        value: country.id,
      }))
      return response
    } catch (error) {
      abortNavigation({
        statusCode: error.response?.status || 500,
        message: error.message,
      })
    }
  }

  async function getLanguages() {
    try {
      const response = await $axios.get('language')
      languages.value = response.data.data.map((language) => ({
        ...language,
        label: language.name,
        value: language.id,
      }))
      return response
    } catch (error) {
      abortNavigation({
        statusCode: error.response?.status || 500,
        message: error.message,
      })
    }
  }

  async function getCurrencies() {
    try {
      const response = await $axios.get('currency')
      currencies.value = response.data.data.map((currency) => ({
        ...currency,
        label: currency.name,
        value: currency.id,
      }))
      return response
    } catch (error) {
      abortNavigation({
        statusCode: error.response?.status || 500,
        message: error.message,
      })
    }
  }

  await Promise.all([
    getCategories(),
    getCountries(),
    getLanguages(),
    getCurrencies(),
  ])

  if (!sessionStorage.getItem('currencySelected'))
    mainStore.setCurrencySelected(
      getCountryBasedCurrency(
        countries.value,
        currencies.value,
        detectedCountryState.value?.toUpperCase()
      )
    )
})
